<app-masters-optionbar> </app-masters-optionbar>
<div class="edit-page-root-container banner-edit-root-container page-root-container">

    <div class="page-content">

        <div class="page-header">

            <div class="page-title">
                <img class="icon" src="assets/images/menu/svg/banner.svg">
                <span>{{title}}</span>
            </div>
            <div class="page-actions">
                <button mat-raised-button color="primary" class="banner-btn new-btn"
                            (click)="addNewBanner()">NEW</button>
            </div>
            <div class="action-btn-container">
                <!-- @if(permission.can_edit){ -->
                <button mat-flat-button class="action-btn btn-discard" (click)="discardChanges()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="saveBanners()">SAVE</button>
            <!-- }-->
            </div>
        </div>

        <!-- <mat-tab-group style="background: transparent;">
            <mat-tab label="Sale items" style="text-align: left;"> -->
                <div class="page-details">
                    <div class="content-container">
                        <div class="detail-section">
                            <div class="edit-form">
                                <div class="form-content-container">
                                    <!-- Header section -->
                                    <div class="banners-header">
                                        <h2 class="mat-headline"></h2>
                                        <div class="banner-actions">
                                            <!-- <button mat-raised-button color="primary" class="banner-btn new-btn"
                                                (click)="addNewBanner()">
                                                NEW
                                            </button> -->
                                            <!-- <button mat-raised-button color="accent" class="banner-btn save-btn"
                                        (click)="saveBanners()">
                                        SAVE
                                    </button>
                                    <button mat-raised-button color="warn" class="banner-btn discard-btn"
                                        (click)="discardChanges()">
                                        DISCARD
                                    </button> -->
                                        </div>
                                    </div>

                                    <!-- Instructions -->
                                    <div class="banner-instructions">
                                        <p><b>Note:</b> The order you set here will determine how banners appear in online store. Drag to rearrange, then Save.</p>
                                    </div>

                                    <!-- Banner grid container -->

                                    <div class="banner-grid-container" cdkDropList cdkDropListOrientation="mixed"
                                        (cdkDropListDropped)="onBannerDrop($event)">
                                        <!-- Banner items -->
                                        <div class="banner-item" *ngFor="let banner of bannerList; let i = index"
                                             cdkDrag [cdkDragData]="banner">
                                            <div class="banner-image-container" cdkDragHandle>
                                                <!-- Banner Image -->
                                                <img [src]="banner.imageUrl" [alt]="banner.name" class="banner-image">
                                                
                                                <!-- 🔧 ADD TIMER ICON FOR BANNERS WITH PERIODS -->
                                                <div class="banner-timer-icon" *ngIf="banner.fromDate || banner.toDate" 
                                                     [matTooltip]="getBannerPeriodTooltip(banner)" 
                                                     matTooltipPosition="below">
                                                    <mat-icon>schedule</mat-icon>
                                                </div>
                                                
                                                <!-- Banner Overlay (for controls) -->
                                                <div class="banner-overlay">
                                                    <div class="banner-controls">
                                                        <button mat-icon-button class="control-btn edit-btn"
                                                                (click)="editBanner(i)"
                                                                matTooltip="Edit Banner">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                        <button mat-icon-button class="control-btn delete-btn"
                                                                (click)="deleteBanner(i)"
                                                                matTooltip="Delete Banner">
                                                            <mat-icon>delete</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                
                                                <!-- Display Order (bottom left corner) -->
                                                <div class="banner-order">{{ banner.displayOrder }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>